import { Fragment, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Fetching } from 'basic-components';

import { When } from 'react-if';
import { Document, Page, PasswordResponses } from 'react-pdf';

import './PdfCore.scss';

const EMPTY_FUN = () => {}

const PdfCore = ({ content = undefined, onCancel = EMPTY_FUN, scale, isLoading = false, onRenderSuccess = EMPTY_FUN }) => {
  const [numPages, setNumPages] = useState(undefined),
        [isFirstPageRendered, setIsFirstPageRendered] = useState(false),
        onPassword = useCallback((callback, reason) => {
          const callbackProxy = password => {
            if (password === null) {
              onCancel()
              return
            }
            callback(password)
          }

          switch (reason) {
            case PasswordResponses.NEED_PASSWORD: {
              // eslint-disable-next-line no-alert
              const password = prompt("Enter the password to open this PDF file.")
              callbackProxy(password)
              break
            }
            case PasswordResponses.INCORRECT_PASSWORD: {
              // eslint-disable-next-line no-alert
              const password = prompt("Invalid password. Please try again.")
              callbackProxy(password)
              break
            }
            default: {
              break
            }
          }
        }, [onCancel]),
        onDocumentLoadSuccess = useCallback(({ numPages }) => {
          setNumPages(numPages)
        }, []),
        onFirstPageRenderSuccess = useCallback(() => {
          onRenderSuccess?.({ content })
          setIsFirstPageRendered(true)
        }, [content, onRenderSuccess])

  useEffect(() => {
    setNumPages(undefined)
    setIsFirstPageRendered(false)
  }, [content])

  return (
    <Fragment>
      <When condition={isLoading && !isFirstPageRendered}>
          {() => (
            <div className="ng-pdf-core ng-pdf-core--is-loading">
              <Fetching 
                  loading
                  size={80} 
              />
            </div>
          )}
      </When>
      <When condition={content}>
        {() => (
          <Document
              className="ng-pdf-core"
              file={`data:application/pdf;base64,${content}`}
              loading=" "
              noData="File is empty."
              onLoadError={console.error}
              onLoadSuccess={onDocumentLoadSuccess}
              onPassword={onPassword}
              renderMode="canvas"
          >
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                  key={`page_${index + 1}`}
                  loading=" "
                  noData="Page is empty."
                  onRenderSuccess={index === 0 ? onFirstPageRenderSuccess : undefined}
                  pageNumber={index + 1}
                  renderInteractiveForms
                  scale={scale}
                  size="A4"
              />
            ))}
          </Document>
        )}
      </When>
    </Fragment>
  )
}

PdfCore.propTypes = {
  content: PropTypes.string,
  isLoading: PropTypes.bool,
  onCancel: PropTypes.func,
  onRenderSuccess: PropTypes.func,
  scale: PropTypes.number.isRequired
}

export default PdfCore;